export enum PaymentDisplaySection {
    'Calculation',
    'AccountList',
    'GiftCard',
    'CreditCard',
    'RedeemPoint',
}
